export default __webpack_public_path__ + "static/media/pomegranate.501e286c.png";